import { Grid, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import { ROLE } from 'constants.js';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleErrors, checkPrivilege } from "common.js";
import { useMaterialUIController, setRoleContext } from "context";
import configurationContext from "contextConfig";
import { PRIVILEGE } from "constants.js";

function Manage() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { roleContext } = controller;
  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [roleData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { 'statusFilter': roleContext.statusFilter, "searchBy": roleContext.searchBy, "searchValue": roleContext.searchValue, };
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const [isRoleContextChanged, setRoleContextChanged] = useState(false);

  const roleDelete = async (id, status) => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/role/remove",
      method: "POST",
      data: { id: id },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200 && response.data.status == 1) {
        if (roleData.data.rows) {
          const roleRows = roleData.data.rows;
          for (const roleKey in roleRows) {
            if (roleRows[roleKey]['id'] == id) {
              setData(prevState => {
                const updatedRoleStatus = prevState.data.rows.map(item => {
                  if (item.id === id) {
                    return { ...item, status: status };
                  }
                  return item;
                })
                return {
                  ...prevState,
                  data: {
                    ...prevState.data,
                    rows: updatedRoleStatus
                  }
                };
              });
            }
          }
        }
        toast.success(t(response.data.message));
      }
      else if (response.status == 200 && response.data.status == 0) {
        toast.error(t(response.data.message));
        setIsLoading(false);
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/role/list",
      method: "POST",
      data: { ...searchFilterData, pageSelected: pageSelected },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
          if (response.data.data.totalCount)
            setResponseResultCount(response.data.data.totalCount);
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setRoleContext(dispatch, initialState.roleContext);
    setRoleContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/role/manage/page-1");
    else
      navigate("/role/manage");
  };

  useEffect(() => {
    const hasChanged = Object.keys(roleContext).some(
      key => roleContext[key] !== initialState.roleContext[key]
    );
    setRoleContextChanged(hasChanged);
  }, [roleContext]);

  const columns = [
    { Header: t("Id"), accessor: "id", align: "left" },
    { Header: t("name"), accessor: "name", align: "left" },
    { Header: t("Status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];
  const finalObj = [];

  const generateActionLinks = (id, status) => {
    if (status != ROLE.DELETED) {
      return (
        <>
          {adminType == PRIVILEGE.SUBADMIN ?
            <>
              {(checkPrivilege("role", "read") || checkPrivilege("role", "write")) ?
                <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/role/edit/" + id) }} variant="caption" color="text" fontWeight="medium" mr={1}>
                  <Tooltip title={t('edit')}><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
                </MDTypography>
                : null}
              {checkPrivilege("role", "delete") ?
                <MDTypography component="a" onClick={() => { roleDelete(id, ROLE.DELETED) }}  >
                  <Tooltip title={t('delete')}><Box className="ActionDelete" ><DeleteIcon /></Box></Tooltip>
                </MDTypography>
                :
                null
              }
            </>
            :
            <>
              <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/role/edit/" + id) }} variant="caption" color="text" fontWeight="medium" mr={1}>
                <Tooltip title={t('edit')}><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
              </MDTypography>
              <MDTypography component="a" onClick={() => { roleDelete(id, ROLE.DELETED) }}  >
                <Tooltip title={t('delete')}><Box className="ActionDelete" ><DeleteIcon /></Box></Tooltip>
              </MDTypography>
            </>
          }

        </>
      );
    }
  }

  if (roleData.data && roleData.data.rows) {
    let roleRecords = roleData.data.rows;
    for (const rowKey in roleData.data.rows) {
      let roleRecord = roleRecords[rowKey];
      if (roleRecord.id > 0) {
        let tempObj = {
          id: '#' + roleRecord.id,
          name: roleRecord.name,
          status: <span className={'statusD' + roleRecord.status}>
            {(roleRecord.status == ROLE.ACTIVE) ? <span>{t('active')}</span> :
              (roleRecord.status == ROLE.INACTIVE) ? <span>{t('inactive')}</span> :
                (roleRecord.status == ROLE.DELETED) ? <span>{t('deleted')}</span> : null}</span>,
          action:
            <span className="actionLinksStyle">
              {generateActionLinks(roleRecord.id, roleRecord.status)}
            </span>
        };
        finalObj.push(tempObj);
      }
    }
  }
  const rows = finalObj;
  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Manage Roles")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(roleData).length > 0) ?
        <MDBox pt={2} pb={2} className="ContentSectionBox">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                <Grid container className="FilterSectionBox" spacing={2}>
                  <Grid item xs={12} sm={2} md={2} >
                    <MDInput
                      select
                      name="statusFilter"
                      label={t('status')}
                      value={searchFilterData.statusFilter}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      className="ManageProductTopSecip"
                      onChange={(obj) => {
                        setRoleContext(dispatch, { ...roleContext, statusFilter: obj.target.value });

                      }} fullWidth
                    >
                      <MenuItem value={2}>{t('all')}</MenuItem>
                      <MenuItem value={1}>{t('active')}</MenuItem>
                      <MenuItem value={0}>{t('inactive')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2}>
                    <MDInput
                      select
                      name="searchBy"
                      label={t('searchBy')}
                      value={searchFilterData.searchBy}
                      InputProps={{
                        classes: { root: "filterStyle" },
                      }}
                      onChange={(obj) => {
                        if (obj.target.value == 'none') {
                          setRoleContext(dispatch, { ...roleContext, searchValue: '', searchBy: obj.target.value });
                        }
                        else
                          setRoleContext(dispatch, { ...roleContext, searchBy: obj.target.value });
                      }} fullWidth
                    >
                      <MenuItem value={'none'}>{t('none')}</MenuItem>
                      <MenuItem value={'name'}>{t('name')}</MenuItem>
                    </MDInput>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} >
                    <FormControl >
                      <MDInput
                        key={'searchValue'}
                        value={searchFilterData.searchValue}
                        disabled={(searchFilterData.searchBy == 'none') ? true : false}
                        type="text"
                        name="searchValue"
                        label={t("searchInput")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(obj) => {
                          setRoleContext(dispatch, { ...roleContext, searchValue: obj.target.value });
                        }} fullWidth />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <FormControl className="filterSubmit">
                      <MDButton disableRipple
                        onClick={() => {
                          navigate("/role/manage");
                          if (typeof pageNo === "undefined")
                            data();
                        }}
                        key="submit" type="submit" color="info" size="small" className="SubmitButton" fullWidth>{t('submit')}</MDButton>
                      {isRoleContextChanged && (
                        <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries={true}
                  responseResultCount={responseResultCount}
                  paginationSize={MyContext.paginationSize}
                  paginationLink={"/role/manage/page-"}
                  pageSelected={pageSelected}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default Manage;
